import { render, staticRenderFns } from "./youtube-video.vue?vue&type=template&id=5bee1302&scoped=true"
import script from "./youtube-video.vue?vue&type=script&lang=js"
export * from "./youtube-video.vue?vue&type=script&lang=js"
import style0 from "./youtube-video.vue?vue&type=style&index=0&id=5bee1302&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bee1302",
  null
  
)

export default component.exports